import { ModalMessage } from '@zorro/design-system/v2/ModalMessage';

type Props = {
  isOpen: boolean;
  onContinue: () => void;
  onGoToDashboard: () => void;
};

export const ExitShoppingFlowModal = ({
  isOpen,
  onContinue,
  onGoToDashboard,
}: Props) => {
  return (
    <ModalMessage
      isOpen={isOpen}
      onClose={onContinue}
      variant="regular"
      title="You're exiting without selecting a plan"
      description="Are you sure you want to stop? You haven't finalized your health plan selection yet"
      primaryLabel="Continue selection"
      onPrimaryAction={onContinue}
      secondaryLabel="Go to dashboard"
      onSecondaryAction={onGoToDashboard}
    />
  );
};
